import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("jr_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function setToken(token) {
    if (token) localStorage.setItem("jr_token", token);
    else localStorage.removeItem("jr_token");
}

export function getToken() {
    return localStorage.getItem("jr_token");
}
